import {
  Book,
  Puzzle,
  Search,
  Shield,
  Sparkles,
  UserCheck,
} from "lucide-react";

export const qualities = [
  {
    id: 1,
    title: "Curiosity-Driven",
    description:
      "I’m always eager to explore new technologies and concepts. This curiosity has driven me to continuously learn and improve my skills, turning challenges into opportunities for growth.",
    icon: Search,
  },
  {
    id: 2,
    title: "Resilient",
    description:
      "I don’t give up easily. From getting stuck in “tutorial hell” to overcoming project roadblocks, I’ve learned to stay persistent and keep pushing forward, no matter the obstacles.",
    icon: Shield,
  },
  {
    id: 3,
    title: "Passionate Learner",
    description:
      "Driven by a deep love for technology, constantly seeking to expand knowledge and skills, and always motivated to learn and grow in the ever-evolving tech landscape.",
    icon: Book,
  },
  {
    id: 4,
    title: "Creative Thinker",
    description:
      "Brings a unique perspective to problem-solving, thinking outside the box to develop innovative solutions that push boundaries and challenge conventional methods.",
    icon: Sparkles,
  },
];
